import React from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";

/**
 *  ModalGeneric - Componente de modal generico para usar en cualquiera instancia
 * @param {Function} isOpen Funcion abrir modal
 * @param {Function} onClose Funcion cerrar modal
 * @param {String} title Titulo del modal.
 * @param {String} size Tamaño del modal.
 * @return {Component} Retorna modal.
 */

export const ModalGeneric = ({
  isOpen,
  onClose,
  children,
  title,
  size,
  scrollBehavior = "inside",
  buttonClose = true,
  layout = "default",
  contentMaxH = "92vh",
  ...props
}) => {
  const btnRef = React.useRef(null);
  const isFillLayout = layout === "fill";

  return (
    <>
      <Modal
        closeOnOverlayClick={false}
        scrollBehavior={isFillLayout ? "inside" : scrollBehavior}
        isCentered
        autoFocus={false}
        finalFocusRef={btnRef}
        motionPreset="slideInBottom"
        size={size || "4xl"}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent
          maxH={isFillLayout ? contentMaxH : undefined}
          display={isFillLayout ? "flex" : undefined}
          flexDirection={isFillLayout ? "column" : undefined}
          overflow={isFillLayout ? "hidden" : undefined}
          {...props}
        >
          <ModalHeader
            flexShrink={isFillLayout ? 0 : undefined}
            dangerouslySetInnerHTML={{ __html: title }}
          ></ModalHeader>
          {buttonClose ? <ModalCloseButton /> : <></>}
          <ModalBody
            flex={isFillLayout ? 1 : undefined}
            overflow={isFillLayout ? "hidden" : undefined}
            display={isFillLayout ? "flex" : undefined}
            flexDirection={isFillLayout ? "column" : undefined}
            minH={isFillLayout ? 0 : undefined}
            pb={isFillLayout ? 4 : undefined}
          >
            {children}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
